import {EMPLOYEE_RELATIONSHIPS} from "../../constants/ActionTypes";

export const setRelationships = (data) => {
    return {
        type: EMPLOYEE_RELATIONSHIPS,
        payload: data
    };
}